import TopBanner from "@components/gangstabet/TopBanner";
import EmeraldCityInfo from "@components/gangstabet/GangstabetInfo.component";
import GbetToken from "@components/gangstabet/GbetToken.component";
import Story from "@components/story/Story.component";
import TopSold from "@components/home/TopSold.component";
import { useEffect } from 'react';

const Gangstabet = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
  return (
    <>
      <TopBanner />
      <EmeraldCityInfo />
      <GbetToken />
      <Story />
      <TopSold displayCount={8} />
    </>
  );
};

export default Gangstabet;
